import { Component, OnInit } from "@angular/core";
import { AbstractControl, FormGroup, FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { CognitoService } from "../../services/cognito.service";
import { Router, RouterModule } from "@angular/router";
import { AuthService } from "../../services/auth.service";
import { NotificationService } from "../../services/notification.service";
import { TranslateService } from "@ngx-translate/core";
import { Store } from "@ngrx/store";
import { AuthError } from "aws-amplify/auth";
import { LucideAngularModule } from "lucide-angular";
import { CommonModule } from "@angular/common";
import { NgOtpInputModule } from "ng-otp-input";

@Component({
  selector: "app-reset-password",
  standalone: true,
  imports: [LucideAngularModule, ReactiveFormsModule, FormsModule, RouterModule, CommonModule, NgOtpInputModule],
  templateUrl: "./reset-password.component.html",
})
export class ResetPasswordComponent implements OnInit{
  resetForm!: UntypedFormGroup;
  emailForm!: UntypedFormGroup;
  loading = false;
  submitted = false;
  fieldTextType!: boolean;
  wrongcode = false;
  validEmail = false

    constructor(private formBuilder: UntypedFormBuilder, public store: Store, public cognitoService: CognitoService,
      public auth: AuthService, public router: Router, private notificationService: NotificationService,
      private traslateService: TranslateService) { }
  

  ngOnInit(): void {
    this.resetForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(8), this.passwordStrengthValidator]],
      passwordValidate: ['', Validators.required],
      code: ['', [Validators.required, Validators.minLength(6)]],
    }, {
      validators: this.passwordMatchValidator,
    });
  
    this.emailForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

      
  get f() { return this.resetForm.controls; }
  get e() { return this.emailForm.controls; }

  async onSubmit() {
    if (this.emailForm.invalid) {
      const title = await this.traslateService.get('NOTIFI.titleWarning').toPromise();
      const detail = await this.traslateService.get(`ERRORS.completeFieldsWarning`).toPromise();
      this.notificationService.showWarning(title, detail)
      return;
    }
  
    let email = (this.e['email'].value || '').toString().trim().toLowerCase();
    this.loading = true;
  
    try {
      await this.cognitoService.handleResetPassword(email);
      this.validEmail = true;
  
      const title = await this.traslateService.get('NOTIFI.titleSuccess').toPromise();
      this.notificationService.showSuccess(title, "Proceso Exitoso");
    } catch (error) {
      const title = await this.traslateService.get('NOTIFI.titleError').toPromise();
      const detail = await this.traslateService.get(`ERRORS.${(error as AuthError).name || 'Error'}`).toPromise();
      this.notificationService.showError(title, detail);
    }
  
    this.loading = false;
  }
  

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  validatePass(password: string): boolean {
    //validamos la fortaleza de la contra, esta funcion lo utilizamos en insertar y modificar
    const passwordStrengthPattern: RegExp = /^(?=(.*\d){2})(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z\d]).{8,}$/;
    return passwordStrengthPattern.test(password);
  }


  passwordsDoNotMatch(): boolean {
    const confirmPasswordControl = this.resetForm.get('passwordValidate');

    return this.resetForm.hasError('passwordsMismatch') &&
      !!confirmPasswordControl && confirmPasswordControl.touched;
  }
  onOtpChange(otp: any) {
    this.wrongcode = false;
    this.resetForm.controls['code'].setValue(otp);
  }
  passwordStrengthValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const value = control.value || '';
    const pattern = /^(?=(.*\d){2})(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z\d]).{8,}$/;
    return pattern.test(value) ? null : { weakPassword: true };
  }
  
  passwordMatchValidator(group: FormGroup): { [key: string]: boolean } | null {
    const password = group.get('password')?.value;
    const confirm = group.get('passwordValidate')?.value;
    return password === confirm ? null : { passwordsMismatch: true };
  }
  
  async onSubmitReset() {
    if (this.resetForm.invalid) return;
  
    const { password, code } = this.resetForm.value;
    const email = this.emailForm.value.email;
  
    this.loading = true;
    try {
      await this.cognitoService.handleConfirmResetPassword(email, code, password);
      const title = await this.traslateService.get('NOTIFI.titleSuccess').toPromise();
      this.notificationService.showSuccess(title, "Contraseña Restaurada");
      this.router.navigateByUrl("/account-login");
    } catch (error) {
      this.wrongcode = true;
      const title = await this.traslateService.get('NOTIFI.titleError').toPromise();
      const detail = await this.traslateService.get(`ERRORS.${(error as AuthError).name || 'Error'}`).toPromise();
      this.notificationService.showError(title, detail);
      const errorName = (error as AuthError).name;
      const shouldRedirect = ![
        "CodeMismatchException",
        "InvalidPasswordException",
      ].includes(errorName);
      
      if (shouldRedirect) {
        this.router.navigateByUrl("/account-login");
      }
    }
    this.loading = false;
  }
  

}
